import SelectedTimeSlot from '@/models/date-picker/SelectedTimeSlot';
import IAvailabilityData from '@/models/test-drive/interfaces/availability-data.d';
import ITestDriveAvailabilityState from './interfaces/test-drive-availability-state.d';

export default class TestDriveAvailabilityState implements ITestDriveAvailabilityState {
    public retailerAvailability: IAvailabilityData[] = [];

    public selectedAvailability: SelectedTimeSlot | null = null;

    public noResults: boolean = false;
}
